import { API_INSTANCE } from 'src/features/utils';

const BASE_URL = '/api/v1/dashboard/api-keys';

export interface APIKey {
  id: string;
  name: string;
  key_preview: string;
  permissions: string[];
  is_active: boolean;
  created_at: string;
  expires_at: string | null;
}

export interface CreateAPIKeyRequest {
  name: string;
}

export interface CreateAPIKeyResponse {
  success: boolean;
  key: string;
  id: string;
  name: string;
  created_at: string;
  expires_at: string | null;
  message: string;
}

export interface GetAPIKeysResponse {
  success: boolean;
  api_keys: APIKey[];
  count: number;
}

export interface DeleteAPIKeyResponse {
  success: boolean;
  message: string;
}

export class APIKeysService {
  private static async request<T>(
    method: 'GET' | 'POST' | 'DELETE',
    endpoint: string,
    data?: any,
  ): Promise<T> {
    try {
      const response = await API_INSTANCE({
        method,
        url: `${BASE_URL}${endpoint}`,
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`API Keys Error (${method} ${endpoint}):`, error);
      throw error;
    }
  }

  static async createAPIKey(request: CreateAPIKeyRequest): Promise<CreateAPIKeyResponse> {
    return this.request<CreateAPIKeyResponse>('POST', '', request);
  }

  static async getAPIKeys(): Promise<GetAPIKeysResponse> {
    return this.request<GetAPIKeysResponse>('GET', '');
  }

  static async deleteAPIKey(id: string): Promise<DeleteAPIKeyResponse> {
    return this.request<DeleteAPIKeyResponse>('DELETE', `/${id}`);
  }
}
